module.exports = __webpack_public_path__ + "img/mark-plan.562775ff.png";